import { render, staticRenderFns } from "./OrderListIframe.vue?vue&type=template&id=3f328c4a&"
import script from "./OrderListIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports